<div class="fl center-arrow-column pv1 dn db-ns">
  <jb-icon
    class="fill-medium-gray"
    name="rightFilled"
    width="1.5em"
    height="1.5em"
  ></jb-icon>
</div>
